<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>person_add</mat-icon></div>
      <div style="flex:1; min-width:0;">
        <h2 class="cf-dlg-title">Personal</h2>
        <p class="cf-dlg-subtitle">Datos del empleado</p>
      </div>
    </div>

    <!-- Fila fija: Nombre + DNI + Toggle -->
    <div style="padding: 14px 24px; border-bottom: 1px solid var(--cf-border); flex-shrink:0; display:grid; grid-template-columns:1fr 1fr auto; gap:0 16px; align-items:flex-start; background:var(--cf-bg);">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Nombre y apellidos</mat-label>
        <input type="text" matInput name="employeesListModel.name" required
          [formControl]="nameFormControl" [(ngModel)]="employeesListModel.name">
      </mat-form-field>
      <app-input inputType="text" placeholder="DNI" name="employeesListModel.Dni" [isRequired]="true"
        [formControl]="dniFormControl"></app-input>
      <div style="padding-top:18px;">
        <mat-form>
          <mat-slide-toggle (change)="changeToggleType($event, 'isActive')" required
            [checked]="employeesListModel.active" name="isActive"
            [ngClass]="{'invalid': !hasToggleSelected}">
            Activo
          </mat-slide-toggle>
        </mat-form>
      </div>
    </div>

    <!-- BODY (scrolleable) -->
    <div class="cf-dlg-body" style="padding:0;">
      <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndexTab">

        <!-- TAB: Datos Personales -->
        <mat-tab label="Datos personales">
          <div style="padding: 16px 24px;">
            <div class="cf-dlg-row">
              <app-input inputType="text" placeholder="Dirección" [(ngModel)]="employeesListModel.address"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-input inputType="email" placeholder="Email" [(ngModel)]="employeesListModel.email"
                [ngModelOptions]="{standalone: true}"></app-input>
            </div>
            <div class="cf-dlg-row">
              <app-input inputType="text" placeholder="Localidad" [(ngModel)]="employeesListModel.city"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-input inputType="text" placeholder="Código postal" [(ngModel)]="employeesListModel.postal_code"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-input inputType="text" placeholder="Provincia" [(ngModel)]="employeesListModel.province"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-input inputType="text" placeholder="País" [(ngModel)]="employeesListModel.country"
                [ngModelOptions]="{standalone: true}"></app-input>
            </div>
            <div class="cf-dlg-row">
              <app-input inputType="text" placeholder="Teléfono" [(ngModel)]="employeesListModel.phone"
                [ngModelOptions]="{standalone: true}"></app-input>
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>IRPF %</mat-label>
                <input type="number" matInput [(ngModel)]="employeesListModel.irpf" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Fecha de nacimiento</mat-label>
                <input matInput [matDatepicker]="date" [(ngModel)]="employeesListModel.birth_date" [ngModelOptions]="{standalone: true}">
                <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                <mat-datepicker #date></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="cf-dlg-row">
              <app-select class="w-100" [(ngModel)]="employeesListModel.marital_status"
                [ngModelOptions]="{standalone: true}" [config]="{ label: 'Estado civil', options: employeesMaritalStatusOptions }"></app-select>
              <app-select class="w-100" [(ngModel)]="employeesListModel.children"
                [ngModelOptions]="{standalone: true}" [config]="{ label: 'Hijos', options: employeesChildrenOptions }"></app-select>
              <app-select class="w-100" [(ngModel)]="employeesListModel.property_type"
                [ngModelOptions]="{standalone: true}" [config]="{ label: 'Tipo de propiedad', options: employeesProperyTypeOptions }"></app-select>
            </div>
          </div>
        </mat-tab>

        <!-- TAB: Datos Laborales -->
        <mat-tab label="Datos laborales">
          <div style="padding: 16px 24px;">
            <div class="cf-dlg-row">
              <app-select class="w-100" [(ngModel)]="employeesListModel.workday"
                [ngModelOptions]="{standalone: true}" [config]="{ label: 'Jornada laboral', options: employeesWorkDayOptions }"></app-select>
              <app-select class="w-100" [(ngModel)]="employeesListModel.contract_type"
                [ngModelOptions]="{standalone: true}" [config]="{ label: 'Tipo de contrato', options: employeesContractTypeOptions }"></app-select>
              <app-input inputType="text" placeholder="Categoría" [(ngModel)]="employeesListModel.category"
                [ngModelOptions]="{standalone: true}"></app-input>
            </div>
            <div class="cf-dlg-row">
              <app-input inputType="number" placeholder="Días de vacaciones anuales" [(ngModel)]="employeesListModel.vacationDaysPerYear"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-input inputType="number" placeholder="Días de vacaciones de años anteriores" [(ngModel)]="employeesListModel.vacationDaysPreviousYears"
                [ngModelOptions]="{standalone: true}"></app-input>
            </div>
            <div class="cf-dlg-row">
              <app-input inputType="text" placeholder="Cuenta bancaria" [(ngModel)]="employeesListModel.bank_account"
                [ngModelOptions]="{standalone: true}"></app-input>
              <app-autocomplete-select [items]="bankAccountBics"
                [(selectedItemId)]="employeesListModel.bicAccountUid" [idField]="'uid'"
                [displayFields]="['bic','bank']" placeholder="BIC" [isRequired]="true">
              </app-autocomplete-select>
              <app-input inputType="text" placeholder="Cuenta contable del empleado" disabled="true"
                [(ngModel)]="employeesListModel.accountingmodels_number" [ngModelOptions]="{standalone: true}"></app-input>
            </div>
            <ng-container *ngIf="employeesActivitiesLoaded">
              <span class="cf-dlg-section__label" style="margin-top:8px">Asignación de nóminas por actividad</span>
              <div class="cf-dlg-row">
                <mat-form-field *ngFor="let activity of employeesActivities; trackBy: trackByIndex" appearance="outline">
                  <mat-label>% en {{ activity.activityName }}</mat-label>
                  <input matInput type="number" min="0" max="100" [(ngModel)]="activity.percentage" name="activity.percentage">
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </mat-tab>

        <!-- TAB: Geolocalización -->
        <mat-tab label="Geolocalización">
          <div style="padding: 16px 24px;">
            <div style="background:var(--cf-bg); border:1px solid var(--cf-border); border-radius:var(--cf-radius); padding:14px; margin-bottom:16px; font-size:13px; color:var(--cf-text-muted);">
              <strong style="color:var(--cf-text); display:block; margin-bottom:6px;">¿Cómo funciona?</strong>
              Solo si <strong>Activar geolocalización</strong> está habilitado, el empleado podrá aceptarla en la app móvil.
            </div>
            <mat-slide-toggle [(ngModel)]="employeesListModel.activarGeolocalizacion" [ngModelOptions]="{standalone: true}" color="primary">
              <span style="font-weight:600">Activar geolocalización</span>
            </mat-slide-toggle>
            <div *ngIf="employeesListModel.activarGeolocalizacion" style="margin-top:14px; display:flex; flex-direction:column; gap:6px; font-size:13px;">
              <div>
                <span style="color:var(--cf-text-muted)">Geolocalización aceptada:</span>
                <strong style="margin-left:8px">{{ employeesListModel.geolocalizacionAceptada ? 'Sí' : 'No' }}</strong>
              </div>
              <div *ngIf="employeesListModel.geolocalizacionAceptada">
                <span style="color:var(--cf-text-muted)">Fecha de aceptación:</span>
                <strong style="margin-left:8px">{{ employeesListModel.geolocalizacionAceptadaFecha | date:'dd/MM/yyyy HH:mm' }}</strong>
              </div>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
